// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"f2d5071e","385":"662153bc","450":"1b9629be","453":"fec6e44d","645":"2f4e1d05","969":"f92d7407"}[chunkId] + ".chunk.js";
};